export const channelFieldHelp = {
  name: {
    description: 'Nome interno do canal na mesa. Não aparece para o cliente.',
    example: 'Suporte E-mail',
  },
  channelType: {
    description:
      'Como as mensagens entram no Go. E-mail (IMAP/SMTP), API (webhook ou poll) ou mensageria (webhook). A resposta humana ou do N1 é escrita na mesa de atendimento; a saída segue o canal configurado.',
    example: 'E-mail — caixa de suporte com N1',
  },
  attendanceMode: {
    description:
      'Manual: só mesa (humano). Auto-reply: ack de abertura. Assistente: Go chama N1 HTTP. Bot externo: conversa automática na plataforma (ex. Chat); Go não responde sozinho.',
    example: 'Assistente — N1 neste canal de e-mail',
  },
  externalInboxId: {
    description:
      'Identificador da caixa no mundo externo. No e-mail, use o endereço que o cliente escreve. Em mensageria, o Inbox ID preenche este campo automaticamente.',
    example: 'suporte@empresa.com',
  },
  defaultCompanyId: {
    description:
      'Empresa à qual os chamados deste canal são vinculados quando o contato ainda não está identificado.',
    example: 'selecione a empresa do contrato de suporte',
  },
  defaultAssignedTeamId: {
    description:
      'Fila que recebe o chamado quando o N1 transfere ou quando não há regra mais específica. Deixe vazio se o roteamento for só pelas regras abaixo.',
    example: 'equipe de N2'
  },
  defaultSlaId: {
    description:
      'SLA padrão do canal: usado na resolução e, se o contrato não definir, também na 1ª resposta.',
    example: 'SLA padrão do contrato',
  },
  outboundChannelConfigId: {
    description:
      'Para onde saem as respostas (humano, N1 e auto-reply). Vazio = mesmo canal. Ex.: entrada por webhook API e saída por SMTP de outro canal.',
    example: 'E-mail · Suporte BTalk',
  },
  imapHost: {
    description:
      'Servidor de leitura da caixa. Se ficar vazio, o Go usa o IMAP cadastrado em Configurações do sistema.',
    example: 'imap.gmail.com',
  },
  imapPort: {
    description: 'Porta IMAP. Com SSL, o usual é 993.',
    example: '993',
  },
  imapUseSsl: {
    description: 'Ligue se o servidor IMAP exige conexão criptografada (quase sempre sim).',
    example: 'marcado para Gmail, Microsoft 365 e provedores comuns',
  },
  imapUsername: {
    description: 'Usuário da caixa. Em geral é o próprio e-mail. Em Gmail com senha de app, use o endereço completo.',
    example: 'suporte@empresa.com',
  },
  imapPassword: {
    description:
      'Senha da caixa ou senha de aplicativo. Em edição, deixe em branco para manter a senha já gravada. Use o olho para conferir o que digitou.',
    example: 'senha de app do Gmail, não a senha da conta Google',
  },
  smtpHost: {
    description: 'Servidor de envio das respostas (N1 e analista). Se vazio, usa o SMTP das configurações do sistema.',
    example: 'smtp.gmail.com',
  },
  smtpPort: {
    description: 'Porta SMTP. Com TLS, o usual é 587. SSL implícito costuma ser 465.',
    example: '587',
  },
  smtpUseTls: {
    description: 'Ligue para STARTTLS na porta 587. Desmarque só se o provedor exigir outro modo.',
    example: 'marcado para Gmail na porta 587',
  },
  smtpUsername: {
    description: 'Usuário SMTP. Quase sempre o mesmo e-mail da caixa.',
    example: 'suporte@empresa.com',
  },
  smtpPassword: {
    description:
      'Senha SMTP ou senha de aplicativo. Em edição, deixe em branco para manter a senha já gravada.',
    example: 'a mesma senha de app usada no IMAP, se for a mesma conta',
  },
  smtpFromAddress: {
    description:
      'Endereço que o cliente vê no From. Precisa ser um remetente autorizado nesse SMTP. Respostas humanas e do N1 saem daqui, na mesma thread.',
    example: 'suporte@empresa.com',
  },
  smtpFromName: {
    description: 'Nome amigável ao lado do e-mail no cliente de correio.',
    example: 'Suporte Empresa',
  },
  signatureHtml: {
    description:
      'Assinatura anexada ao final de cada e-mail deste canal. Use o editor para texto, formatação e imagem (botão de imagem). A versão em texto puro é gerada automaticamente.',
    example: 'Atenciosamente — Equipe de Suporte + logotipo',
  },
  smtpTestTo: {
    description:
      'Destino do e-mail de teste. O envio usa o SMTP já salvo neste canal (salve antes se mudou host ou senha). Se vazio, o teste vai para o próprio remetente.',
    example: 'seu.email@empresa.com',
  },
  assistantEnabled: {
    description:
      'Definido pelo Modo de atendimento = Assistente. O Go chama a API do N1 após a mensagem virar chamado.',
    example: 'modo Assistente neste canal',
  },
  historyMessageCount: {
    description:
      'Quantas mensagens públicas anteriores da thread entram em {{history}}. 0 = só a mensagem atual. Máximo 50.',
    example: '5 — últimas 5 mensagens da conversa',
  },
  escalateToHumanOnFailure: {
    description:
      'Se o N1 falhar (rede, 5xx, timeout, de-para vazio), pausa o assistente neste chamado, deixa na fila humana e notifica a equipe do ticket.',
    example: 'ligado no piloto',
  },
  assistantMethod: {
    description: 'Método HTTP da request do assistente, como no Postman. O usual em APIs de chat é POST.',
    example: 'POST',
  },
  assistantUrl: {
    description:
      'URL completa da API que processa a mensagem. Cada provedor usa a sua. A resposta é convertida pelo de-para do canal para o contrato interno (text, threadId, handoff). Obrigatória se o N1 estiver ligado.',
    example: 'https://api.provedor.com/api/integration/chat',
  },
  assistantHeaders: {
    description:
      'Headers extras da request, em JSON. Content-Type application/json é o padrão. Authorization não vai aqui se a autenticação estiver no painel ao lado.',
    example: '{ "Content-Type": "application/json" }',
  },
  assistantBody: {
    description:
      'Corpo da request. {{message}} já inclui remetente, assunto e corpo. Também: {{subject}}, {{fromAddress}}, {{threadId}}, {{ticketCode}}, {{ticketId}} e {{history}} (últimas N mensagens públicas).',
    example:
      '{ "agentId": "guid-do-agente", "threadId": "{{threadId}}", "message": "{{message}}", "history": "{{history}}" }',
  },
  assistantAuthType: {
    description:
      'Como autenticar a request do assistente, no padrão Postman. None = sem Authorization. Bearer/Basic/API Key = credencial estática. API de autenticação = o Go chama outra URL, lê o token e aplica na request do assistente.',
    example: 'API de autenticação — quando o provedor gera Bearer a partir de clientId e clientSecret',
  },
  assistantAuthUsername: {
    description:
      'Usuário do Basic, ou valor de {{authUsername}} no body/headers da API de token. Não é o token do chat.',
    example: 'o clientId da credencial, se o body usar {{authUsername}}',
  },
  assistantApiKeyHeader: {
    description: 'Nome do header que carrega a API Key na request (do assistente ou da API de token, conforme o tipo).',
    example: 'X-Api-Key',
  },
  assistantAuthSecret: {
    description:
      'Segredo guardado no canal. Em Bearer estático, é o token. Em Basic, a senha. Em API Key, o valor da chave. Em API de autenticação, é o valor de {{authSecret}} no body da API de token (em geral o clientSecret) — não o Bearer do chat. Em edição, deixe em branco para manter.',
    example: 'clientSecret da credencial de integração',
  },
  authRequestMethod: {
    description: 'Método HTTP da API que devolve o token. O usual é POST.',
    example: 'POST',
  },
  authRequestUrl: {
    description:
      'URL que gera o token. O Go chama esta URL primeiro. Obrigatória se o tipo for API de autenticação e o N1 estiver ligado.',
    example: 'https://api.provedor.com/api/token',
  },
  authRequestAuthType: {
    description:
      'Como autenticar a própria chamada de token — não a do assistente. None: clientId e secret vão no body. Bearer/Basic/API Key: o Go manda Authorization ou header usando o Secret / Token acima. Se a API de token recebe JSON com clientId/clientSecret, use None.',
    example: 'None (credencial no body)',
  },
  tokenJsonPath: {
    description:
      'Nome do campo JSON na resposta da API de token. O Go lê esse valor e aplica na request do assistente.',
    example: 'token — ou access_token, conforme a resposta do provedor',
  },
  tokenApplyAs: {
    description:
      'Como o token obtido entra na request do assistente. Bearer monta Authorization: Bearer {token}. Basic usa o token como senha. Header usa o nome informado ao lado.',
    example: 'Bearer',
  },
  tokenHeaderName: {
    description: 'Header customizado onde o token obtido será enviado, se Aplicar token como = Header.',
    example: 'Authorization',
  },
  authRequestHeaders: {
    description: 'Headers da chamada de token, em JSON. Não coloque o Bearer do chat aqui.',
    example: '{ "Content-Type": "application/json" }',
  },
  authRequestBody: {
    description:
      'Corpo da API de token. Use {{authSecret}} para o valor do campo Secret / Token e {{authUsername}} para o usuário. Com Auth desta API = None, as credenciais ficam só neste JSON.',
    example: '{ "clientId": "guid-do-cliente", "clientSecret": "{{authSecret}}" }',
  },
  responseTextJsonPath: {
    description:
      'Caminho JSON do texto que vai para o cliente. Aceita notação com ponto (ex.: data.message). O provedor de conhecimento atual usa textResponse. sources não entram no e-mail.',
    example: 'textResponse',
  },
  responseThreadIdJsonPath: {
    description:
      'Caminho JSON do id de conversa no provedor. O Go grava no chamado e reenvia em {{threadId}}. Se o campo não existir na resposta, a conversa segue sem contexto persistido no provedor.',
    example: 'threadId',
  },
  responseHandoffJsonPath: {
    description:
      'Caminho JSON do sinal de transferência para humano. true = não envia e-mail automático. Se o campo não vier, o Go assume false.',
    example: 'handoff',
  },
  apiMode: {
    description:
      'Webhook: o provedor envia eventos para o endpoint deste canal. Poll: o Go consulta a URL periodicamente.',
    example: 'Webhook (escutar)',
  },
  apiMethod: {
    description: 'Método HTTP da consulta, usado no modo Poll. No webhook, a entrada no Go é sempre POST no endpoint do canal.',
    example: 'GET no modo Poll',
  },
  apiUrl: {
    description: 'URL que o Go consulta no modo Poll. No modo Webhook este campo é opcional. Também serve de fallback se OutboundUrl estiver vazio.',
    example: 'https://api.exemplo.com/v1/events',
  },
  apiOutboundUrl: {
    description:
      'URL HTTP para enviar respostas (API out). Se vazio, o Go usa a URL de Poll/entrada. Obrigatória quando este canal é o de saída e não há URL de entrada.',
    example: 'https://api.exemplo.com/v1/messages',
  },
  apiOutboundMethod: {
    description: 'Método HTTP do envio de respostas. Em geral POST.',
    example: 'POST',
  },
  apiOutboundBody: {
    description:
      'JSON (ou texto) da resposta. Placeholders: {{ticketId}}, {{ticketCode}}, {{externalConversationId}}, {{body}}, {{to}}. Em JSON, o Go escapa automaticamente.',
    example:
      '{ "ticketCode": "{{ticketCode}}", "body": "{{body}}", "to": "{{to}}" }',
  },
  apiHeaders: {
    description: 'Headers da consulta Poll, em JSON. Authorization pode ir aqui ou no painel Autenticação.',
    example: '{ "Content-Type": "application/json" }',
  },
  apiAuthType: {
    description:
      'Autenticação da consulta Poll e, se configurada, também validada na entrada do webhook. None, Bearer, Basic ou API Key — padrão Postman.',
    example: 'Bearer Token',
  },
  apiAuthUsername: {
    description: 'Usuário do Basic Auth na API deste canal.',
    example: 'integration-user',
  },
  apiApiKeyHeader: {
    description: 'Nome do header que carrega a API Key nas chamadas deste canal.',
    example: 'X-Api-Key',
  },
  apiAuthSecret: {
    description:
      'Token Bearer, senha Basic ou valor da API Key. Em edição, deixe em branco para manter o valor já gravado.',
    example: 'token de integração do provedor',
  },
  apiWebhookEndpoint: {
    description:
      'URL gerada pelo Go. Cadastre este endereço no provedor para ele enviar os eventos. Clique no campo para copiar.',
    example: '/api/v1/integrations/channels/{id}/webhook',
  },
  apiWebhookSecret: {
    description:
      'Segredo HMAC para validar a assinatura do provedor (X-Webhook-Signature ou X-Signature). Em edição, deixe em branco para manter.',
    example: 'a mesma chave configurada no provedor',
  },
  chatBaseUrl: {
    description:
      'URL base do provedor de mensageria (entrada/saída deste canal), sem barra no final. Obrigatória se o canal estiver ativo. A conversa com o cliente na mesa do Go é a tela de atendimento.',
    example: 'https://mensageria.exemplo.com',
  },
  chatAccountId: {
    description: 'Identificador numérico da conta no provedor de mensageria.',
    example: '1',
  },
  chatInboxId: {
    description: 'ID da inbox no provedor. Também vira o identificador externo do canal.',
    example: '12',
  },
  chatAssistantName: {
    description: 'Nome interno deste canal na mesa. Não precisa ser o nome no provedor.',
    example: 'Suporte N1',
  },
  chatApiAccessToken: {
    description:
      'Token de API do provedor de mensageria. Obrigatório na criação se o canal estiver ativo. Em edição, deixe em branco para manter.',
    example: 'token de acesso da conta',
  },
  chatWebhookEndpoint: {
    description:
      'URL gerada pelo Go para o provedor enviar eventos. Clique no campo para copiar e cadastre no provedor.',
    example: '/api/v1/integrations/channels/{id}/webhook',
  },
  chatWebhookSecret: {
    description:
      'Segredo HMAC opcional (X-Chat-Signature ou X-Webhook-Signature). Em edição, deixe em branco para manter.',
    example: 'chave compartilhada com o provedor',
  },
  routingRules: {
    description:
      'Descartar remetentes ignora a mensagem. Abrir sem responder cria o chamado sem N1/ack/auto-reply. Agrupar alertas junta ocorrências iguais na janela informada. Padrões usam contains (ex.: @eveo.com.br).',
    example:
      'Descartar: @eveo.com.br · Abrir sem responder: noreply@ · Agrupar: btalk-suporte@ com janela 24h',
  },
  webhookEnabled: {
    description:
      'Quando ativo, cada resposta (triagem, bot ou operador) e cada mudança de status saem por esta request, no lugar do e-mail. Canais sem o webhook continuam pela caixa.',
    example: 'ligado no canal de suporte do Talk',
  },
  webhookUrl: {
    description:
      'URL absoluta (http ou https) do sistema que vai receber a atualização. O Go não conhece o contrato: o corpo e os headers são os que você montar aqui.',
    example: 'https://api.exemplo.com/support/events',
  },
  webhookBody: {
    description:
      'Corpo da request, como no Postman. {{status}} e {{previousStatus}} já saem convertidos pelo mapa. {{goStatus}} e {{goPreviousStatus}} mantêm o nome do Go. {{message}} é o texto da resposta.',
    example: '{ "status": "{{status}}", "message": "{{message}}" }',
  },
  webhookStatusMap: {
    description:
      'Converte o status do Go antes do envio. Ex.: Resolvido pode sair como Closed. Linha vazia não entra no mapa; status sem linha sai com o nome do Go.',
    example: 'Resolvido → Closed',
  },
  isEnabled: {
    description:
      'Canal ativo entra na leitura (IMAP, webhook ou chat). Desmarque para pausar sem apagar a configuração.',
    example: 'marcado para a caixa de produção',
  },
} as const;
